'use client';

import {ColumnDef} from '@tanstack/react-table';
import {Body} from '@/components/body';
import {Heading} from '@/components/heading';
import {Button} from '@/components/ui/button';
import {ArrowUpDown} from 'lucide-react';

// This type is used to define the shape of our data.
// You can use a Zod schema here if you want.
export type Subprocessor = {
  name: string;
  purpose: string;
  location: string;
};

export const columns: ColumnDef<Subprocessor>[] = [
  {
    accessorKey: 'name',
    header: ({column}) => {
      return (
        <Button
          variant="ghost"
          className="hover:bg-grey-1"
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
        >
          Servizio
          <ArrowUpDown className="ml-2 h-4 w-4" />
        </Button>
      );
    },
    cell: ({row}) => {
      return <Heading variant="h5">{row.getValue('name')}</Heading>;
    },
  },
  {
    accessorKey: 'purpose',
    header: 'Scopo',
    cell: ({row}) => {
      return <Body>{row.getValue('purpose')}</Body>;
    },
  },
  {
    accessorKey: 'location',
    header: 'Posizione',
    cell: ({row}) => {
      return <Body>{row.getValue('location')}</Body>;
    },
  },
];
